// File excluded from token migration due to custom illustration
// https://atlassian.slack.com/archives/CFJ9DU39U/p1709665443238399
import React from 'react';
import { styled } from '@compiled/react';

import Image from '@atlaskit/image';
import { token } from '@atlaskit/tokens';

import DarkIllustration from '../assets/LandInEditorIllustrationDark.svg';
import LightIllustration from '../assets/LandInEditorIllustrationLight.svg';

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const IllustrationContainer = styled.div({
	width: '330px',
	height: '150px',
	marginTop: token('space.300'),
	backgroundColor: token('elevation.surface'),
	borderRadius: `${token('radius.small')} ${token('radius.small')} 0 0`,
	borderBottom: `${token('border.width')} solid ${token('color.background.accent.gray.subtler')}`,
	'@media screen and (max-width: 375px)': {
		marginTop: token('space.600'),
	},
	'@media screen and (max-width: 1024px)': {
		marginTop: token('space.300'),
	},
});

// Note: this is used for Land In Editor Banner
export const TemplateBannerIllustration = (): React.JSX.Element => {
	return (
		<IllustrationContainer>
			<Image
				src={LightIllustration}
				srcDark={DarkIllustration}
				alt=""
				testId="template-banner-illustration"
			/>
		</IllustrationContainer>
	);
};
